import {connect} from 'react-redux';
import axios from 'axios';
import {Platform} from "react-native"

import LoginEnterPhoneScreen from '../LoginEnterPhoneScreen';
import {
    serviceActionPendingShahrdar,
    serviceActionSetState,
    serviceActionSetToken, serviceActionSetTokenLaravel, serviceActionSetTokenMahaleh,
    serviceActionSetTypeLogin,
    serviceActionSetUser,
    serviceActionSuccess as serviceActionSuccessSplash, serviceActionSuccessSaina, serviceActionSuccessShahrdar
} from "../../../splash/action/ActionSplashGetAllData";
import * as NavigationService from "../../../../../redux/NavigationService";
import {AsyngStorageClass} from "../../../../../tools/AsyngStorageClass";
import base64 from 'react-native-base64'
import store from "../../../../../redux/store";
import {typeExport} from "../../../../../redux/store/type";
import {Tools} from "../../../../../tools/Tools";

const mapStateToProps = (state) => ({
    results: state.reducerLoginEnterPhoneScreen.results,
    NoInternetDialog: state.reducerLoginEnterPhoneScreen.NoInternetDialog,
    isLoading: state.reducerLoginEnterPhoneScreen.isLoading,

    DataSplashScreen: state.reducerSplashGetAllData,
});

const mapDispatchToProps = (dispatch, getState) => ({
    callService: (url, params, type, typeConnection, stateData) => dispatch(callWebservice(getState, url, params, type, typeConnection, stateData)),
    callServiceSetState: (data) => dispatch(serviceActionSetState(data)),
    callServiceError: (data) => dispatch(serviceActionError(data)),
    callServiceRefresh: () => dispatch(serviceActionRefresh()),

})

const getDataDisatch = (dispatch, getState, url, params, type, typeConnection, stateData) => {
    dispatch(serviceActionPending());

    let token = `Basic ${base64.encode(params.username + ':' + params.password)}`
    let checkSearch = (typeExport._Shahrdar.search("shahrdar_") >= 0);

    const formData = new FormData();
    formData.append('_operation', checkSearch && (stateData.indexSelectType === 1) ? typeExport._Shahrdar : params._operation);
    formData.append('lang', params.lang);
    formData.append('mode', checkSearch && (stateData.indexSelectType === 1) ? "Login" : params.mode);
    formData.append('username', params.username);
    formData.append('password', params.password);
    formData.append('token', token);
    formData.append('platform', Platform.OS);
    // formData.append('token_fb', params.token_fb);
    formData.append('token_fb', store.getState().reducerSplashGetAllData.token_fb);
    //formData.append('device', global._Device);
    formData.append('device', global._Device ? global._Device.value : null);

    Tools.addAllFormData(formData, true, "City");
    //php
    // const config = {
    //     headers: {
    //              'Content-Type': 'multipart/form-data',
    //         // 'Content-Type': 'application/json',
    //         "Authorization": token,
    //         timeout: typeExport._TIMEOUT,
    //     }
    // };


    // axios(
    //      {
    //          url: url ,
    //          method: typeConnection,
    //         params:paramsSend,
    //      //     data: {
    //      //         _operation: 'Contacts',
    //      //     },
    //          headers: {
    //              'Content-Type': 'application/x-www-form-urlencoded',
    //              "Authorization": `Basic ${base64.encode(params.username + ':' + params.password)}`
    //
    //          },
    //
    //      }
    //  )

    //php
    axios({
        method: 'post',
        url: url,
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data',
            "Authorization": token
        },
        timeout: typeExport._TIMEOUT,
    })
    //asp
    // let str = Tools.convertFormDataToSoap("LoginShahrdar", formData);
    // console.log("str", str);
    // const config = {
    //     headers: {
    //         "Content-Type": "multipart/form-data; charset=utf-8;",
    //         // 'Content-Type': 'application/json',
    //         ///"Authorization": `Basic ${base64.encode(params.username + ':' + params.password)}`,
    //         timeout: typeExport._TIMEOUT,
    //     }
    // };
    // axios({
    //     method: 'post',
    //     url: "http://192.168.168.192:81/service1.asmx",
    //     data: str,
    //     headers: {
    //         'Content-Type': 'text/xml; charset=utf-8',
    //         //    "Authorization": token
    //     },
    //     timeout: typeExport._TIMEOUT,
    //
    // })
    // axios.post(url, formData, config)
        .then(async response => {
                let data = response.data;
                let checkLogin = (params._operation == typeExport._login)

                switch (type) {

                    case typeExport.TypegetDataLoginEnterPhoneScreen:
                        if (data.success) {
                            let {type, item, indexSelectType} = stateData;
                            let operation = data.result.operation;
                            if (operation == 2) {
                                dispatch(serviceActionSuccessShahrdar(data.result))
                            }
                            else {
                                dispatch(serviceActionSuccessSaina(data.result))
                            }
                            let check_indexSelectType = (operation === 2) ? true : ((indexSelectType + 1) === 2);
                            //  await AsyngStorageClass.setAsyng(typeExport._TypeLogin, (checkLogin) ? 2 : 1);
                            await AsyngStorageClass.setAsyng(typeExport._TypeLogin, operation ? operation : indexSelectType + 1);
                            // dispatch(serviceActionSetTypeLogin((checkLogin) ? 2 : 1));

                            await AsyngStorageClass.setAsyng(typeExport._USER, data.result);
                            await AsyngStorageClass.setToken(data.result.session ? data.result.session : data.result.token)
                            if (data.result.token_mahale) {
                                let tokenMahale = data.result.token_mahale;
                                await AsyngStorageClass.setAsyng("tokenMahaleh", tokenMahale);
                                dispatch(serviceActionSetTokenMahaleh(tokenMahale));
                            }
                            else if (data.result.tokenLaravel) {
                                let tokenLaravel = data.result.tokenLaravel;
                                await AsyngStorageClass.setAsyng("tokenLaravel", tokenLaravel);
                                dispatch(serviceActionSetTokenLaravel(tokenLaravel));
                            }


                            dispatch(serviceActionSuccess(data))
                            dispatch(serviceActionSuccess(data))
                            dispatch(serviceActionSetUser(data.result))
                            dispatch(serviceActionSetToken(data.result.session ? data.result.session : data.result.token))
                            dispatch(serviceActionSetTypeLogin(operation ? operation : indexSelectType + 1));
                            if (check_indexSelectType) {
                                dispatch(serviceActionSuccessSplash(null));
                                //   NavigationService.resetTo('SplashScreen')
                            }
                            if (global.ErrorLogin || checkLogin || (check_indexSelectType) || ((operation ? operation : (indexSelectType + 1)) === 3)) {
                                // NavigationService.resetTo('SplashScreen')
                                NavigationService.resetTo('SplashScreen')

                            }
                            else {
                                if (type) {
                                    //NavigationService.pop();

                                    NavigationService.navigateParams(type, {item})

                                    store.dispatch(serviceActionSetState(null))
                                }
                                else {
                                    // if (global.ErrorLogin) {
                                    //     global.ErrorLogin = false
                                    //     NavigationService.resetTo('SplashScreen')
                                    // }
                                    //
                                    // else
                                    Platform.OS === "web" ?
                                        window.history.back()
                                        //  this.props.history.goBack()
                                        :
                                        getState.navigation.pop()
                                }
                            }


                        } else {
                            alert(data && data.error ? data.error.message : "سرور با مشکل مواجه شده")
                            dispatch(serviceActionRefresh())

                        }
                        break;


                    default:
                }
            }
        ).catch((e) => {

        dispatch(serviceActionError(e))
    })
}


export const callWebservice = (getState, url, params, type, typeConnection, stateData) => {

    return dispatch => {


        // NetInfo.isConnected.fetch().then(isConnected => {
        //     if (isConnected) {
        //         getDataDisatch(dispatch, getState, url, params, type, typeConnection, stateData);
        //     }
        //     else {
        //         dispatch(serviceActionError("No Internet Connection"));
        //
        //     }
        // });

        // NetInfo.getConnectionInfo().done(
        //     (isConnected) => {
        //         if (isConnected) {
        //             getDataDisatch(dispatch, getState, url, params, type, typeConnection, stateData);
        //         } else {
        //             dispatch(serviceActionError("No Internet Connection"));
        //
        //         }
        //     }
        // )

        if (store.getState().reducerSplashGetAllData.Connection) {
            getDataDisatch(dispatch, getState, url, params, type, typeConnection, stateData);
        } else {
            dispatch(serviceActionError("No Internet Connection"));

        }


    }
}


export const serviceActionPending = () => ({
    type: typeExport.LoginEnterPhoneScreen_SERVICE_PENDING,
    NoInternetDialog: false,
    isLoading: true,
    results: null

})

export const serviceActionError = (error) => ({
    type: typeExport.LoginEnterPhoneScreen_SERVICE_ERROR,
    NoInternetDialog: true,
    isLoading: false,
    error: error
})

export const serviceActionSuccess = (data) => ({
    type: typeExport.LoginEnterPhoneScreen_SERVICE_SUCCESS,
    NoInternetDialog: false,
    isLoading: false,
    results: data,


})

export const serviceActionRefresh = () => ({
    type: typeExport.LoginEnterPhoneScreen_SERVICE_REFRESH,
    NoInternetDialog: false,
    isLoading: false,
    results: null
})
export default connect(mapStateToProps, mapDispatchToProps)(LoginEnterPhoneScreen);
